import { ROUTING_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const MedianFirstResponseQuery: CubeQuery = {
  name: 'MedianFirstResponse',
  query: {
    measures: [
      ROUTING_MEASURES.MEDIAN_TIME_TO_FIRST_RESPONSE,
      ROUTING_MEASURES.ROUTING_REQUEST_TO_TEAMMATE_ROUTED_IN,
      ROUTING_MEASURES.RESPONSE_COUNT,
    ],
    filters: [],
  },
  queryName: ROUTING_MEASURES.MEDIAN_TIME_TO_FIRST_RESPONSE,
}
